export const config = {
    baseUrl: 'https://api.eddygames.net',
    // baseUrl: 'http://{process.env.EDDY_BACKEND_URL}',
    // baseUrl: 'http://127.0.0.1:8080',
    // baseUrl: 'http://127.0.0.1:8085',
    // baseUrl: 'http://54.83.87.100:8080',
    tokenHeader: 'x-auth-token',
};
